import { EOrderStatus } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { OrderGroupDetailed } from 'src/reactQuery/orders/interfaces/orderGroup.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const updateOrderGroupStatus = async (
  projectId: string,
  orderGroupId: string,
  status: EOrderStatus
): Promise<OrderGroupDetailed | undefined> => {
  const response = await apiM7.put(
    `${API_URL_M7}/api_admin/v1/project/${projectId}/ecommerce/order-group/${orderGroupId}`,
    { status },
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
